export const METERING_POINT_FETCH = 'METERING_POINT_FETCH';
export const METERING_POINT_UPDATE = 'METERING_POINT_UPDATE';
export const METERING_POINT_AGR_DATA_FETCH = 'METERING_POINT_AGR_DATA_FETCH';

export const CONSUMPTION_METERING_POINT_UPDATE =
  'CONSUMPTION_METERING_POINT_UPDATE';
export const METERING_POINT_ACTIVATION = 'METERING_POINT_ACTIVATION';
export const METERING_POINT_REVIEW_FETCH = 'METERING_POINT_REVIEW_FETCH';
export const METERING_POINT_GENERATE_GO = 'METERING_POINT_GENERATE_GO';
